<template>
	<div class="container-fluid">
		<materials-tasks-toolbar title="Material Assemblies">
		</materials-tasks-toolbar>

		<collapsible-panel :external-toggle="panelOpen" v-on:panelRetract="panelOpen = false">
			<template slot="panel">
				<h3 v-if="tags.length > 0">Filter By Tag</h3>

				<p v-else>You can set up tags to better organize your assemblies. <router-link to="/materials/settings">Add some tags now</router-link></p>

				<!--<panel-menu :menu-items="tagMenu" class="mb-2"
					:active-item="tagFilter"
					v-on:itemClick="navigateToTag">
				</panel-menu>-->

				<label v-for="tag in tags" class="tag-label">
					<input type="checkbox" :value="tag.friendly_slug" v-model="selectedTags" v-on:change="fetchAssemblies(true)">
					{{tag.name}}
				</label>
			</template>
			<template slot="main">
				<button class="btn btn-light mr-1" v-on:click="panelOpen = true" :disabled="panelOpen">
					<i class="fa fa-filter"></i>
					Filter
				</button>

				<button class="btn btn-success" v-on:click="newAssembly">
					<i class="fa fa-plus"></i>
					New Material Assembly
				</button>

				<table-list key="mainList"
					record-name="Assembly Item"
					:fields="[
						{label: 'Description',key:'description'},
						{label: 'Tags',key:'tagsList'}
						//{label: 'Materials in Assembly',key:'materialCount'},
						//{label: 'Total Pieces in Assembly',key:'pieceCount'}
					]"
					:records="mutatedAssemblies"
					:has-edit="true"
					:has-delete="true"
					hide-record-count="true"
					:sortable="true"
					delete-endpoint="MaterialAssembly/delete"
					v-on:edit="editAssembly"
					v-on:modelChange="fetchAssemblies(true)">
				</table-list>
			</template>
		</collapsible-panel>

		<assembly-details-modal
			:visible="editModal.visible"
			:title="editModal.title"
			:readonly="false"
			:record="editModal.record"
			v-on:closeModal="editModal.visible = false;editModal.record = {}"
			v-on:modelChanged="fetchAssemblies(true)">
		</assembly-details-modal>
	</div>
</template>

<script type="text/javascript">
import TableList from "@/components/TableList"
import MaterialsTasksToolbar from "./MaterialsTasksToolbar"
import AssemblyDetailsModal from "@/components/super_components/AssemblyDetailsModal"

import InfoBox from "@/components/InfoBox"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import draggable from "vuedraggable"

import Field from "@/components/Field"

export default {
	name: "MaterialAssemblies",
	components: {
		TableList,
		MaterialsTasksToolbar,
		Field,
		AssemblyDetailsModal,
		InfoBox,
		draggable,
		CollapsiblePanel
	},
	data() {
		return {
			assemblies: [],
			tags: [],
			selectedTags: [],
			panelOpen: false,
			editModal: {
				visible: false,
				title: "",
				record: null
			},
			matFields: [
				{label: "Part Number",key:"part_number"},
				{label: "Description",key:"description"},
				//{label: "Category", key: "parentCategoryName"},
				{label: "Qty",key:"qty"},
				{label: "Trade Price", key: "material_price",align:"right"},
				{label: "Labour (hrs/unit)",key:'labour_hrs',align:'right'},
				{label: "Per",key: "per",align:'right'}
			]
		}
	},
	computed: {
		tagOptions() {
			return this.optionify(this.tags,"name")
		},
		mutatedAssemblies() {
			return this.assemblies.map(as => {

				as.tagsList = ""
				if ("AssemblyTag" in as && as.AssemblyTag) {
					as.tagsList = as.AssemblyTag.reduce((acc,tag) => {
						return acc+"<span class='badge badge-primary mr-1'>"+tag.name+"</span>"
					},"")
				}

				//as.materialCount = as.MaterialAssemblyItem.length

				//as.pieceCount = as.MaterialAssemblyItem.reduce((acc,mat) => acc + +mat.qty,0)

				return as
			})
		},
	},
	methods: {

		newAssembly() {
			this.editModal.record = {
				description: "",
				Material: []
			}

			this.editModal.visible = true
			this.editModal.title = "New Material Assembly"
		},
		editAssembly(assembly) {
			let vm = this

			let fieldsToSet = ["id","description","unit_type","note_unit","note_linear","note_segments"]

			if (assembly) {
				vm.editModal.record = {}

				fieldsToSet.forEach(field => {
					if (field in assembly)
						vm.editModal.record[field] = assembly[field]
				})

				this.editModal.record.AssemblyTag = assembly.AssemblyTag.map(tag => tag.id)
			}

			//this.editModal.materials = assembly.MaterialAssemblyItem
			this.editModal.visible = true
			this.editModal.title = "Edit Material Assembly"

			//this.fetchAssemblyItems(assembly.id)
		},
		fetchAssemblies(spinner) {
			if (spinner)
				this.spinner(true)

			let vm = this

			let params = {
				include: ["AssemblyTag"]
			}

			if (vm.selectedTags.length > 0) {
				params.filters = [
					["AssemblyTag.friendly_slug",vm.selectedTags]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("MaterialAssembly/get",params).then(response => {
					if (spinner)
						vm.spinner(false)

					if (response.success) 
						vm.assemblies = response.data

					resolve(response)
				})

			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchAssemblies(),
				this.getJSON("AssemblyTag/get")
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[1].success) {
					vm.tags = responses[1].data
				}
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>
